/** Resolve the FK-safe calls.owner_id for a locally authoritative owner. */
export function resolveDurableOwnerId(
  participantOwnerId: string | null,
  isAuthoritativeOwner: boolean,
  authenticatedUserId: string | null | undefined,
): string | undefined {
  const isUuid = (value: unknown): boolean =>
    typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
  if (typeof participantOwnerId === 'string' && isUuid(participantOwnerId)) return participantOwnerId;
  if (typeof participantOwnerId === 'string' && participantOwnerId.trim() && isAuthoritativeOwner
      && typeof authenticatedUserId === 'string' && isUuid(authenticatedUserId)) {
    return authenticatedUserId;
  }
  return undefined;
}
